var CHECK_CIRCLE_ICON =
  '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M8 12.5l2.5 2.5L16 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

document.addEventListener('DOMContentLoaded', function () {
  // Filters open as a floating dropdown anchored to the button. The button's
  // active (colored) state is server-rendered from whether any filter is
  // applied, so it is not touched here.
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filters-panel]');
  if (filterToggle && filterPanel) {
    var filterWrap = filterToggle.closest('[data-filter]') || filterPanel.parentElement;

    function closeFilters() {
      filterPanel.setAttribute('hidden', '');
      filterToggle.setAttribute('aria-expanded', 'false');
    }

    filterToggle.addEventListener('click', function (event) {
      event.stopPropagation();
      if (filterPanel.hasAttribute('hidden')) {
        filterPanel.removeAttribute('hidden');
        filterToggle.setAttribute('aria-expanded', 'true');
      } else {
        closeFilters();
      }
    });

    // Clicks inside the panel shouldn't reach the document-level closer.
    filterPanel.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    // Close when clicking outside, or on Escape — like the catalog menu.
    document.addEventListener('click', function (event) {
      if (!filterPanel.hasAttribute('hidden') && !filterWrap.contains(event.target)) {
        closeFilters();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !filterPanel.hasAttribute('hidden')) {
        closeFilters();
      }
    });
  }

  // The sort dropdown sits in the toolbar but posts the filters form, whose
  // submit button is inside the (possibly hidden) panel. Apply it on change so
  // sorting works without opening the filters.
  var sortSelect = document.getElementById('SortBy');
  var facetForm = document.getElementById('FacetFiltersForm');
  if (sortSelect && facetForm) {
    sortSelect.addEventListener('change', function () {
      facetForm.submit();
    });
  }

  var grid = document.querySelector('[data-product-grid]');
  var toggle = document.querySelector('[data-view-toggle]');

  if (toggle && grid) {
    toggle.querySelectorAll('[data-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        toggle.querySelectorAll('[data-view]').forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });
        grid.classList.toggle('is-list-view', button.dataset.view === 'list');
      });
    });
  }

  document.querySelectorAll('[data-quick-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('[data-add-to-cart-button]');
      if (!button || button.disabled) return;

      var originalContent = button.innerHTML;

      fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          button.classList.add('is-added');
          button.innerHTML =
            '<span class="product-card__add-icon">' + CHECK_CIRCLE_ICON + '</span><span>Agregado</span>';
          setTimeout(function () {
            button.classList.remove('is-added');
            button.innerHTML = originalContent;
          }, 2000);
        })
        .catch(function () {
          form.submit();
        });
    });
  });
});
